import { StandardEvents } from '@shopify/events';

(() => {
  const header = document.querySelector('[data-gv-header]');
  if (!header) return;

  const drawer = document.querySelector('[data-gv-nav-drawer]');
  const openBtn = document.querySelector('[data-gv-nav-open]');
  const closeBtns = document.querySelectorAll('[data-gv-nav-close]');

  const syncCartCount = (count) => {
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-gv-cart-count]').forEach((el) => {
      el.textContent = String(count);
    });
  };

  const setHeaderHeights = () => {
    const group = document.getElementById('header-group');
    const ann = group?.querySelector('.gv-ann');
    const headerH = header.offsetHeight || 0;
    const annH = ann?.offsetHeight || 0;
    document.body.style.setProperty('--header-height', `${headerH}px`);
    document.body.style.setProperty('--header-group-height', `${headerH + annH}px`);
  };

  setHeaderHeights();
  window.addEventListener('resize', setHeaderHeights);

  const openNav = () => {
    if (!drawer) return;
    drawer.hidden = false;
    openBtn?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('gv-nav-open');
  };

  const closeNav = () => {
    if (!drawer) return;
    drawer.hidden = true;
    openBtn?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('gv-nav-open');
  };

  openBtn?.addEventListener('click', openNav);
  closeBtns.forEach((btn) => btn.addEventListener('click', closeNav));

  drawer?.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeNav();
  });

  document.addEventListener('cart:update', (event) => {
    syncCartCount(event.detail?.resource?.item_count);
  });

  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise
      ?.then(({ cart }) => {
        if (typeof cart?.totalQuantity === 'number') syncCartCount(cart.totalQuantity);
      })
      .catch(() => {});
  });
})();
